import { useState, useEffect } from "react";
import "./Carousel.scss";
import arrow from "../../assets/arrow.svg";

const Carousel = ({ images }) => {
    const [current, setCurrent] = useState(0);

    const prevSlide = () => {
        setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    const nextSlide = () => {
        setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, 5000);

        return () => clearInterval(interval);
    }, [current]);

    return (
        <div className="Papaya-Carousel">
            <div className="Papaya-Carousel-preview">
                <div className="arrow left" onClick={prevSlide}>
                    <img alt="" src={arrow} />
                </div>
                <div className="Papaya-Carousel-preview-img" >
                    <img src={images[current].src} alt="" />
                    <div className="Papaya-Carousel-preview-img-label">{images[current]?.name}</div>
                </div>
                <div className="arrow right" onClick={nextSlide}>
                    <img alt="" src={arrow} />
                </div>
            </div>
            <div className="Papaya-Carousel-thumbs">
                {images.map((img, i) => (
                    <img
                        key={i}
                        src={img.src}
                        alt=""
                        className={`Papaya-Carousel-thumbs-img`}
                        onClick={() => setCurrent(i)}
                    />
                ))}
            </div>
        </div >
    );
};

export default Carousel;
